import React, { useContext, useMemo } from 'react';

import styles from './SubmittedPurchaseOrders.module.scss';

import { getStoresLimit } from '../../../api/users';
import { StoresStateContext } from '../../../context/stores/StoresProvider';
import { useGlobalContext } from '../../../context/global/GlobalContext';
import { SubmittedPOsList } from './submitted-pos-list/SubmittedPOsList';
import { PurchaseOrdersNav } from './PurchaseOrdersNav';
import { Footer } from '../../layout/footer/Footer';
import { CreatePoButton } from './create-po-button/CreatePoButton';

import { SearchPO } from '../../common/search-po/SearchPO';

export const submittedPurchaseOrdersTestId = 'submittedPurchaseOrdersTestId';

export const SubmittedPurchaseOrders = () => {
  const { stores: initialStores, loading } = useContext(StoresStateContext);
  const { poStores } = useGlobalContext();

  // TODO: show something when loading
  const canFilterPOsByStore =
    !loading && initialStores.length === getStoresLimit;

  const hasPOs = poStores && poStores?.length > 0;

  return useMemo(
    () => (
      <div
        className={styles.sectionWrapper}
        data-testid={submittedPurchaseOrdersTestId}
      >
        <PurchaseOrdersNav />
        {loading ? null : canFilterPOsByStore ? (
          <>
            <SearchPO />
            {hasPOs && <SubmittedPOsList poStores={poStores} />}
          </>
        ) : (
          <SubmittedPOsList />
        )}
        <Footer>
          <CreatePoButton />
        </Footer>
      </div>
    ),
    [loading, canFilterPOsByStore, hasPOs, poStores]
  );
};
